import _ from "lodash";
import CategoryService from "../category/CategoryService";
import {SOURCE_CATEGORY_VIEW} from "../../constants";
import EventBus from "../../../plugins/event-bus";
import {ON_CATEGORY_CREATED, ON_CATEGORY_UPDATED} from "../../../plugins/event-bus/event-bus-names";

const category = {
  namespaced: true,
  state: {
    currentDepartment: {},
    modal: {
      show: false,
      object: null,
      source: null
    },
  },
  getters: {
    flattenedCategories: state => {
      if (state.currentDepartment && state.currentDepartment.categories) {
        let flattenedCategories = [];
        state.currentDepartment.categories.forEach((cat) => CategoryService.iterate(cat, flattenedCategories));
        return flattenedCategories;
      }

      return [];
    }
  },
  actions: {
    showModal({commit}, {object = null, source} = {}) {
      commit('showModal', {object: _.cloneDeep(object), source});
    },
    hideModal({commit}) {
      commit('hideModal');
    },
    async updateCurrentDepartment({commit}, department) {
      return await commit('updateCurrentDepartment', department);
    },
    async updateDepartmentCategories({rootState, state}, departmentUuid) {
      let {body: categories} = await CategoryService.getCategories({
        department_uuid: departmentUuid,
        expand: 'children'
      });

      let department = rootState.setup.department.departments.rows.find(dep => dep.uuid === state.currentDepartment.uuid);
      department.categories = categories;

      state.currentDepartment.categories = categories;
      return true
    },
    async createCategory({dispatch, state}, category) {
      let departmentUuid = state.currentDepartment.uuid;
      let response = await CategoryService.createCategory({...category.toJSON(), department_uuid: departmentUuid});

      if (response.success && state.modal.source === SOURCE_CATEGORY_VIEW) {
        await dispatch('updateDepartmentCategories', departmentUuid);
      }

      return response;
    },
    async updateCategory({state, dispatch}, category) {
      let departmentUuid = state.currentDepartment.uuid;
      let response = await CategoryService.updateCategory(category.uuid, {
        ...(category.toJSON ? category.toJSON() : category),
        department_uuid: departmentUuid
      });

      if (response.success) {
        await dispatch('updateDepartmentCategories', departmentUuid);
      }

      return response;
    },
    async removeCategory({dispatch, state}, uuid) {
      let response = await CategoryService.removeCategory(uuid);
      if (response.success) {
        await dispatch('updateDepartmentCategories', state.currentDepartment.uuid);
      }
      return response;
    }
  },
  mutations: {
    showModal: (state, {object, source}) => {
      state.modal.show = true;
      state.modal.object = object;
      state.modal.source = source;
    },
    hideModal: state => state.modal.show = false,
    updateCurrentDepartment: (state, department) => state.currentDepartment = department,
  }
};

export default category;
